module.exports = {
    help: {
        pages: 1,
        pageNameFormat: 'res/help/page_%d.jpg',
        priceFontName: 'help_font',
        backgroundMusic: 'res/sounds/help_ambient',
        click:'res/sounds/click',
        pricetable: [
            {
                symbol:0,   // конек-горбунок
                wins:[5,4,3,2],
                position:{x:234, y:107-35},
                offset:{width:0, height:27},
                align:'center'
            },
            {
                symbol:1,   // Жар птица
                wins:[5,4,3,2],
                position:{x:918, y:107-35},
                offset:{width:0, height:27},
                align:'center'
            },
            {
                symbol:2,   // Василиса и Емеля (или Иван, хз)
                wins:[5,4,3,2],
                position:{x:339, y:275-35},
                offset:{width:0, height:27},
                align:'center'
            },
            {
                symbol:4,   // Царь
                wins:[5,4,3],
                position:{x:918, y:285-35},
                offset:{width:0, height:32},
                align:'center'
            },
            {
                symbol:5,   // Град и Кит
                wins:[5,4,3],
                position:{x:918, y:451-35},
                offset:{width:0, height:32},
                align:'center'
            },
            {
                symbol:7,   // Горшок и Сундук
                wins:[5,4,3],
                position:{x:339, y:451-35},
                offset:{width:0, height:32},
                align:'center'
            },
            {
                symbol:9,   // Кольцо, Б, В
                wins:[5,4,3],
                position:{x:530, y:614-35},
                offset:{width:0, height:32},
                align:'center'
            },
            {
                symbol:12,   // А
                wins:[5,4,3,2],
                position:{x:918, y:605-35},
                offset:{width:0, height:27},
                align:'center'
            }
        ]
    }
};



//////////////////
// WEBPACK FOOTER
// ./cfg/help-config.js
// module id = 16
// module chunks = 0